import { IconButton } from '../ui';
import { mediaUrl } from '../../api/client';
import { sendDisplay, type DisplayPayload } from '../../lib/display';
import { useUiStore } from '../../store/uiStore';

export interface ShowButtonProps {
  slug: string;
  /** Media-relative image path (e.g. "images/x.png"). */
  image?: string;
  title?: string;
  caption?: string;
  instanceId?: string;
}

/**
 * "Show on player display" button. Broadcasts an image to the player-display window.
 * Disabled (with a hint) when the entity has no image.
 */
export function ShowButton({ slug, image, title, caption, instanceId }: ShowButtonProps) {
  const toast = useUiStore((s) => s.toast);
  const disabled = !image;

  const onClick = () => {
    if (!image) return;
    const payload: DisplayPayload = {
      src: mediaUrl(slug, image),
      title,
      caption,
      fit: 'contain',
    };
    sendDisplay('image', payload, instanceId);
    toast(`Mostrato ai giocatori: ${title ?? 'immagine'}`, 'success');
  };

  return (
    <IconButton
      label={disabled ? 'Nessuna immagine da mostrare' : 'Mostra ai giocatori'}
      onClick={onClick}
      disabled={disabled}
      size="sm"
    >
      📺
    </IconButton>
  );
}
